interface IEnvironments {
  [propName: string]: string;
}
export const Environments: IEnvironments = {
  STAGING: 'STAGING',
  DEV: 'DEV',
  QA: 'QA',
  LOCAL: 'LOCAL',
  LION: 'LION',
  TIGER: 'TIGER',
  BEAR: 'BEAR',
};
